module.exports = __webpack_public_path__ + "static/media/robotswarm.f4859838.jpg";